import React from 'react';
import Badge from '../ui/Badge';

const buildKpis = (threshold) => ([
  { id: 'average', label: 'Average Attendance %', valueKey: 'average', suffix: '%' },
  { id: 'below90', label: 'Below 90%', valueKey: 'below90' },
  { id: 'below70', label: `Below ${threshold}%`, valueKey: 'below70' },
  { id: 'flagged', label: 'Safeguarding Flagged', valueKey: 'flagged' }
]);

export default function AttendanceKpis({ counts, activeKpi, onSelect, threshold = 70 }) {
  const kpis = buildKpis(threshold);
  return (
    <div className="sp-kpi-grid" role="tablist" aria-label="Attendance KPIs">
      {kpis.map((kpi) => {
        const isActive = activeKpi === kpi.id;
        const value = counts[kpi.valueKey] ?? 0;
        return (
          <button
            key={kpi.id}
            type="button"
            className={`sp-kpi-card ${isActive ? 'sp-kpi-card--active' : ''}`}
            onClick={() => onSelect?.(kpi.id)}
            aria-pressed={isActive}
          >
            <div className="sp-kpi-label">{kpi.label}</div>
            <div className="sp-kpi-value">
              {value}
              {kpi.suffix || ''}
            </div>
            {kpi.id === 'below70' && value > 0 && <Badge variant="danger">High risk</Badge>}
            {kpi.id === 'flagged' && value > 0 && <Badge variant="danger">Safeguarding</Badge>}
          </button>
        );
      })}
    </div>
  );
}
